import React, { useState, useEffect } from "react";
import axios from "axios";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import GlobalStyle from './GlobalStyle';
import { FaTrash, FaEdit, FaFileExport } from "react-icons/fa";
import { useLocation } from "react-router-dom";

const columnWidths = { 
  orderId: "250px", 
  pagato: "180px" 
};

const PageContainer = styled.div`
  background-color: #fffdf3;
  padding: 5px;

  @media (max-width: 1024px) {
    padding: 10px;
  }

  @media (max-width: 768px) {
    padding: 10px 5px;
  }
`;

const Input = styled.input`
  width: 100%;
  padding: 10px;
  margin: 6px 0;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;

  @media (max-width: 768px) {
    font-size: 12px;
    padding: 6px;
  }
`;

const Button = styled.button`
  padding: 6px 10px;
  background: #28a745;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 6px;

  &:hover {
    background: #218838;
  }

  &:disabled {
    background: #ccc;
    cursor: not-allowed;
  }

  @media (max-width: 768px) {
    padding: 4px 8px;
    font-size: 12px;
    gap: 4px;
  }
`;

const DangerButton = styled(Button)`
  background: #dc3545;

  &:hover {
    background: #c82333;
  }
`;

const FiltersContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  width: 100%;
  margin-bottom: 10px;

  & > * {
    flex: 1 1 160px;
    min-width: 120px;
  }

  @media (max-width: 768px) {
    gap: 8px;
    & > * {
      flex: 1 1 140px;
      min-width: 100px;
    }
  }
`;

const TableWrapper = styled.div`
  overflow-x: auto;
  width: 100%;
`;

const StyledTable = styled.table`
  width: 100%;
  min-width: 600px;
  border-collapse: collapse;

  th, td {
    border: 1px solid #ddd;
    padding: 10px;
    text-align: left;
  }

  th {
    background-color: #f9f9f9;
    font-weight: 600;
  }

  tr:nth-child(even) {
    background-color: #fefefe;
  }
`;


const OrdersEdit = () => {
  const [orders, setOrders] = useState([]);
  const [filters, setFilters] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const ORDERS_PER_PAGE = 20;
  const navigate = useNavigate();
  const location = useLocation();
  const orderId = location.state?.orderId;

useEffect(() => {
 const fetchOrdersAndDrivers = async () => {
 try { const [ordersRes] = await Promise.all([ axios.get("/api/corrs"), ]);
      const ordersData = Array.isArray(ordersRes.data)
          ? ordersRes.data.map((order) => ({
              ...order,
              products: order.products ? (typeof order.products === 'string' ? JSON.parse(order.products) : order.products) : [],
            }))
          : [];
        setOrders(ordersData);
      } catch (error) {
        console.error("Errore caricamento dati:", error);
      }
  };
  fetchOrdersAndDrivers();
}, []);


// Eliminazione
const handleDeleteOrder = async (orderId) => {
  const confirm = window.confirm("Sei sicuro di voler eliminare questo corrispettivo?");
  if (!confirm) return;
  try {
await axios.delete("/api/deleteCorr", { data: { orderId } });
    setOrders(prev => prev.filter(order => order.orderId !== orderId));
    alert("Corrispettivo eliminato con successo.");
  } catch (error) {
    alert("Errore durante l'eliminazione del corrispettivo.");
  }
};

// Esportazione corrispettivo a zucchetti
const handleCreaBolla = async (orderId) => {
  const confirm = window.confirm("Sei sicuro di voler esportare questo corrispettivo?");
  if (!confirm) return;
  try {
    await axios.post("/api/creaCorr", { orderId });
    alert("Corrispettivo creato con successo!");
  } catch (error) {
    console.error("Errore durante la creazione del corrispettivo:", error);
    alert("Errore durante la creazione del corrispettivo.");
  }
};

  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
    setCurrentPage(1);
  };

  const visibleKeys = orders.length > 0
    ? Object.keys(orders[0]).filter(
        (key) => !["createdAt", "products", "orderDate"].includes(key)
      )
    : [];

  const filteredOrders = orders.filter((order) =>
    [...visibleKeys, "pagato"].every((key) =>
      filters[key]
        ? order[key]?.toString().toLowerCase().includes(filters[key].toLowerCase())
        : true
    )
  );

// Paginazione e filtri
  const paginatedOrders = filteredOrders.slice(
    (currentPage - 1) * ORDERS_PER_PAGE,
    currentPage * ORDERS_PER_PAGE
  );
  const totalPages = Math.ceil(filteredOrders.length / ORDERS_PER_PAGE);
  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };
// ##################################

// RETURN
  return (
    <>
      <GlobalStyle />
      <PageContainer>
        <h4>Gestione corrispettivi</h4>
        <FiltersContainer>
          <Input placeholder="Filtra per cliente / data" value={filters.orderId || ""} onChange={(e) => handleFilterChange("orderId", e.target.value)} />
          <Input placeholder="Filtra per pagato" value={filters.pagato || ""} onChange={(e) => handleFilterChange("pagato", e.target.value)} />
        </FiltersContainer>

        <TableWrapper>
          <StyledTable>
            <thead>
              <tr>
                <th style={{ width: columnWidths.orderId }}>Ordine</th>
                <th style={{ width: columnWidths.pagato }}>Pagato</th>
                <th>Azioni</th>
              </tr>
            </thead>
            <tbody>
              {paginatedOrders.map((order, index) => (
                <tr key={index}>
                  <td>{order.orderId}</td>
                  <td>{order.pagato}</td>
                  <td>
                    <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
		        <Button onClick={() => navigate(`/corrs-edit-products/${encodeURIComponent(order.orderId)}`)}>
                        <FaEdit /> <span className="button-label">Modifica</span>
                      </Button>
                      <DangerButton onClick={() => handleCreaBolla(order.orderId)}>
                        <FaFileExport /> <span className="button-label">Esporta</span>
                      </DangerButton>
                      <DangerButton onClick={() => handleDeleteOrder(order.orderId)}>
                        <FaTrash />
                      </DangerButton>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </StyledTable>
        </TableWrapper>

        <div style={{ marginTop: "20px", display: "flex", justifyContent: "center", gap: "10px" }}>
          <Button onClick={() => goToPage(currentPage - 1)} disabled={currentPage === 1}>← Pagina precedente</Button>
          {[...Array(totalPages)].map((_, i) => (
            <Button key={i} onClick={() => goToPage(i + 1)} style={{ backgroundColor: currentPage === i + 1 ? "#007bff" : "#28a745", fontWeight: currentPage === i + 1 ? "bold" : "normal" }}>{i + 1}</Button>
          ))}
          <Button onClick={() => goToPage(currentPage + 1)} disabled={currentPage === totalPages}>Pagina successiva →</Button>
        </div>
      </PageContainer>
    </>
  );
};

export default OrdersEdit;
